<template>
    <div>
        <b-card>
          <h3>Optional Custom Threshold</h3>
          <b-row>
            <b-col><p class="small">Here you can configure Hot & Cold temperatures and a flow frequency for use in custom scenarios</p></b-col>
          </b-row>
          <br/>
          <b-row>
            <b-col>These questions can be defaulted if no configuration required</b-col>
            <b-col><b-button variant="outline-info" v-on:click="SkipPage()">Use Default Values</b-button></b-col>
          </b-row>
          <hr/>
          <b-row>
            <b-col cols="1">Q1</b-col>
            <b-col align="left">Minimum Outlet Hot Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.Custom.CustomHot" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q2</b-col>
            <b-col align="left">Maximimum Outlet Cold Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.Custom.CustomCold" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q3</b-col>
            <b-col align="left">Expected outlet flow frequency</b-col>
            <b-col><b-form-input type="number" v-model="Values.Custom.CustomFlow" placeholder="00"></b-form-input></b-col>
            <b-col align="left">Hours</b-col>
          </b-row>
          <hr/>
          <b-row><b-col><b-button variant="outline-success" v-if="stepComplete == false" v-on:click="CompletePage()">Page Complete</b-button></b-col></b-row>

        </b-card>
    </div>
</template>

<script>
    export default {
      props:['DataPass','Type','ID'],
      data() {
      return {
        stepComplete: false,
        InvalidNum: false,
        Values: {
          Custom: {
                CustomHot: "",
                CustomCold: "",
                CustomFlow: ""
                    }
      }
    }
    },
    computed: {},
    components: {},
    mounted(){
      if (this.Type == 'Modify'){

        this.Values.Custom.CustomHot = this.DataPass.Custom.CustomHot
        this.Values.Custom.CustomCold = this.DataPass.Custom.CustomCold
        this.Values.Custom.CustomFlow = this.DataPass.Custom.CustomFlow
      } else {
        this.Values.Custom.CustomHot = 0
        this.Values.Custom.CustomCold = 0
        this.Values.Custom.CustomFlow = 0
      }


       
    },
    methods:{
      CompletePage(){
        if (this.NumberCheck(this.Values) == true){
          alert("Please ensure entries contain only valid numbers")
        } else{
        this.$emit("PageComplete",6,this.Values)
        this.stepComplete = true;
        }
      },
      SkipPage(){
        this.Values.Custom.CustomHot = 0
        this.Values.Custom.CustomCold = 0
        this.Values.Custom.CustomFlow = 0

        this.$emit("PageComplete",6,this.Values)
        this.stepComplete = true;
      },
      NumberCheck(data){
        this.InvalidNum = false
        
        let invalidcustomhot = /^\d{1,3}(\.\d+)?$/.test(data.Custom.CustomHot)
        let invalidcustomcold = /^\d{1,3}(\.\d+)?$/.test(data.Custom.CustomCold)
        let invalidcustomflow = /^\d{1,3}(\.\d+)?$/.test(data.Custom.CustomFlow)
        
        
        if (!invalidcustomhot || !invalidcustomcold || !invalidcustomflow){
          this.InvalidNum = true
        }

        return this.InvalidNum
      }
    },

    }
</script>

<style>

</style>